import { render, staticRenderFns } from "./BaseExternalRequestMixin.vue?vue&type=template&id=08a80bf0&"
import script from "./BaseExternalRequestMixin.vue?vue&type=script&lang=js&"
export * from "./BaseExternalRequestMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports